// src/redux/actions/salesActions.js
import { 
    GET_PARTNER_DISCLAIMER_REQUEST, 
    GET_PARTNER_DISCLAIMER_SUCCESS, 
    GET_PARTNER_DISCLAIMER_FAILURE 
} from '../../../../Constants/actionTypes';
import { getPartnerDisclaimer } from '../../../../Constants/apiService'

// Fetch Sales Request Action
export const getPartnerDisclaimerRequest = () => ({
    type: GET_PARTNER_DISCLAIMER_REQUEST,
});

// Fetch Sales Success Action
export const getPartnerDisclaimerSuccess = (salesData) => ({
    type: GET_PARTNER_DISCLAIMER_SUCCESS,
    payload: salesData,
});

// Fetch Sales Failure Action
export const getPartnerDisclaimerFailure = (error) => ({
    type: GET_PARTNER_DISCLAIMER_FAILURE,
    payload: error,
});

// Thunk Action Creator for Fetching Sales
export const getPartnerDisclaimerAct = () => {
    return async (dispatch, getState) => {
        dispatch(getPartnerDisclaimerRequest());
        const state = getState();
        const accessToken = state.auth.accessToken;

        try {
            const data = await getPartnerDisclaimer(accessToken);
            dispatch(getPartnerDisclaimerSuccess(data));
            return data; // Ensure the API response is returned
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(getPartnerDisclaimerFailure(errorMessage));
            return { error: errorMessage }; // Return error response to the caller
        }
    };
};

